const MONTH_NAMES = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

const monthNumber = (value) => {
  if (Number.isInteger(value)) return value;
  const numeric = Number(value);
  if (Number.isInteger(numeric)) return numeric;
  const index = MONTH_NAMES.findIndex(
    (name) => name.toLowerCase() === String(value).trim().toLowerCase(),
  );
  return index === -1 ? NaN : index + 1;
};

/** Flatten course + nested Session so month fields are readable at the top level. */
const resolveCourseSessionSource = (course, session = null) => {
  if (!course || typeof course !== "object") return null;
  const sessionPlain =
    (session && typeof session === "object" ? session : null) ||
    (course.Session && typeof course.Session === "object"
      ? course.Session
      : null);
  const { Session: _nested, ...courseFields } = course;
  return {
    ...courseFields,
    ...(sessionPlain || {}),
    Session: sessionPlain || null,
  };
};

export const generateCourseFeePeriods = (course, session = null) => {
  const source =
    resolveCourseSessionSource(course, session || course?.Session) || course;
  const year = Number(source?.year);
  const start = monthNumber(source?.startMonth);
  const end = monthNumber(source?.endMonth);
  if (!Number.isInteger(year) || year < 1) return [];
  if (
    !Number.isInteger(start) ||
    !Number.isInteger(end) ||
    start < 1 ||
    start > 12 ||
    end < 1 ||
    end > 12
  ) {
    return [];
  }

  const periods = [];
  let month = start;
  let periodYear = year;
  do {
    periods.push({
      month,
      year: periodYear,
      label: `${MONTH_NAMES[month - 1]} ${periodYear}`,
    });
    if (month === end) break;
    month += 1;
    if (month === 13) {
      month = 1;
      periodYear += 1;
    }
  } while (periods.length <= 12);
  return periods;
};
